/**
 * Used for property name enforcement for form fields
 */
export const nameof = <T>(key: keyof T & string) => {
    return key;
};
